<template>
  <el-drawer class="reservation-order-history" size="600px" title="訂單紀錄" :visible="syncShow" @close="onClose">
    <HistoryRecord :historyData="displayData">
      <template v-slot="{record}">
        <div class="space-y-[4px]">
          <p class="record-content">{{ record.mainText }}</p>
          <p v-if="record.source" class="record-operator">
            <span class="w-[60px]">來源</span>
            <span class="text-gray-60">{{ record.source }}</span>
          </p>
          <p v-if="record.operator" class="record-operator">
            <span class="w-[60px]">操作人員</span>
            <span class="text-gray-60">{{ record.operator }}</span>
          </p>
        </div>
      </template>
    </HistoryRecord>
  </el-drawer>
</template>

<script>
import { defineComponent, computed, watch, ref } from 'vue'
import { useVModel } from '@vueuse/core'
import { FindReservationOrderHistory } from '@/api/reservation'
import { useFetch } from '@/use/fetch'
import { useShop } from '@/use/shop'
import HistoryRecord from '@/components/HistoryRecord/HistoryRecord.vue'
import { orderHistoryEventTypeConfig, orderHistorySourceConfig } from '@/config/reservation'
import { get, map } from 'lodash'

export default defineComponent({
  name: 'ReservationOrderHistory',
  components: { HistoryRecord },
  props: {
    show: Boolean,
    orderId: String,
    reservationId: String,
  },
  emit: ['update:show', 'close'],
  setup (props, { emit }) {
    const syncShow = useVModel(props, 'show', emit)
    const { fetchAll } = useFetch()
    const { shopId } = useShop()
    const loading = ref(false)
    const historyData = ref([])

    const onClose = () => {
      syncShow.value = false
      setTimeout(() => {
        emit('close')
      }, 0)
    }

    const displayData = computed(() => {
      return map(historyData.value, (record) => {
        const typeConfig = get(orderHistoryEventTypeConfig, record.type)
        const sourceConfig = get(orderHistorySourceConfig, record.source)
        const shouldHideSource = ['updatedTime', 'updatedInfo'].includes(record.type) && record.source === 'system'

        // 當來源是 'admin' 時，操作者是 User.name
        const operatorName = get(record, 'User.name')

        // 是否為金流通知
        const isPaymentNotify = get(record, 'data.isPaymentNotify', false)

        const sourceLabel = sourceConfig?.label || ''
        const paymentNotifySuffix = isPaymentNotify ? '（金流通知）' : ''
        const source = shouldHideSource || !sourceLabel ? '' : `${sourceLabel}${paymentNotifySuffix}`

        return {
          updatedAt: record.updatedAt,
          id: record.id,
          mainText: typeConfig ? typeConfig.label : '',
          source,
          operator: operatorName || '',
        }
      })
    })

    watch(syncShow, async (show) => {
      if (show) {
        loading.value = true
        await fetchAll(FindReservationOrderHistory, {
          shopId: shopId.value,
          orderId: props.orderId,
          reservationId: props.reservationId,
        },
        (res) => {
          historyData.value = res
        })
        loading.value = false
      }
    })

    return { syncShow, onClose, historyData, displayData }
  },
})
</script>

<style lang="postcss" scoped>
.record-content {
  @apply font-bold text-sub text-gray-100;
}

.record-operator {
  @apply font-medium text-sub text-gray-100 flex gap-[12px];
}
</style>
